import React from 'react';

export default ({ width = 18, height = 24 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 18 24"
    >
      <path
        fill="#FFA959"
        d="M17.167 15.03c0 4.77-3.657 8.637-8.167 8.637S.833 19.799.833 15.029c0-4.74 4.579-9.9 7.097-13.546C8.46.717 8.723.334 8.998.333c.275 0 .543.381 1.08 1.144 2.519 3.59 7.089 8.571 7.089 13.552z"
      ></path>
      <path
        fill="url(#paint0_linear_986_627)"
        d="M17.167 15.03c0 4.77-3.657 8.637-8.167 8.637S.833 19.799.833 15.029c0-4.74 4.579-9.9 7.097-13.546C8.46.717 8.723.334 8.998.333c.275 0 .543.381 1.08 1.144 2.519 3.59 7.089 8.571 7.089 13.552z"
      ></path>
      <path
        fill="url(#paint1_radial_986_627)"
        d="M17.167 15.03c0 4.77-3.657 8.637-8.167 8.637S.833 19.799.833 15.029c0-4.74 4.579-9.9 7.097-13.546C8.46.717 8.723.334 8.998.333c.275 0 .543.381 1.08 1.144 2.519 3.59 7.089 8.571 7.089 13.552z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_986_627"
          x1="0.833"
          x2="22.421"
          y1="0.333"
          y2="7.236"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD3AB"></stop>
          <stop offset="0.26" stopColor="#FFC481"></stop>
          <stop offset="0.5" stopColor="#FFC87D"></stop>
          <stop offset="0.828" stopColor="#D99025"></stop>
          <stop offset="1" stopColor="#CB7A00"></stop>
        </linearGradient>
        <radialGradient
          id="paint1_radial_986_627"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(117.496 3.262 7.285) scale(17.3401 15.483)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF383"></stop>
          <stop offset="0.299" stopColor="#FCCE43"></stop>
          <stop offset="0.626" stopColor="#E78233"></stop>
          <stop offset="1" stopColor="#B3460E"></stop>
        </radialGradient>
      </defs>
    </svg>
  );
};
